import { defineField } from 'sanity';

export const MembershipRankSectionSchema = defineField({
	name:   'membershipRankSection',
	title:  'Membership Rank Section',
	type:   'object',
	fields: [
		defineField({
			name:       'title',
			title:      'Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:  'description',
			title: 'Description',
			type:  'localizedText',
		}),
		defineField({
			name:  'ranks',
			title: 'Ranks',
			type:  'array',
			of:    [
				defineField({
					type:   'object',
					name:   'rankItem',
					title:  'Rank Item',
					fields: [
						defineField({
							name:       'title',
							title:      'Title',
							type:       'localizedText',
							validation: Rule => Rule.required(),
						}),
						defineField({
							name:       'subtitle',
							title:      'Subtitle',
							type:       'localizedText',
							validation: Rule => Rule.required(),
						}),
						defineField({
							name:    'image',
							title:   'Image',
							type:    'image',
							options: { hotspot: true },
						}),
						defineField({
							name:       'description',
							title:      'Description',
							type:       'localizedBlockContent',
							validation: Rule => Rule.required(),
						}),
					],
				}),
			],
		}),
	],
});